import React from 'react';
import { Alert } from '@metarouter-private/mr-mui';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';
import DRAWER_MODES from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider/DRAWER_MODES';
import buildPipelineVariablesNote from './buildPipelineVariablesNote';

// Advanced-mode banner stating which pipeline-variable values the test run
// will use. Renders nothing until the selected pipeline's data has resolved.
export default function PipelineVariablesNote() {
  const { mode, pipelineContext } = useTestPlaybookDrawerContext();

  if (mode !== DRAWER_MODES.ADVANCED || !pipelineContext.ready) {
    return null;
  }

  const note = buildPipelineVariablesNote(pipelineContext);
  if (!note) {
    return null;
  }

  return <Alert severity={note.severity}>{note.message}</Alert>;
}
